// MMC
const API = 'https://api.mmcturismo.com';

export const environment = {
    ASSISTCARDLATAM: false,
    production: true,
    API: API,
    PAYPAL_CLIENT_ID: "", ambiente: "GENIUS",
    THEME: "", //(FRT - ARKBEDS - FRT-BLACK)
    //Módulos de turismo
    VALIDAPRAZOCANCELAMENTOMANUTENCAO: false,
    USA_CASAMENTO: false,
    USA_CONTRATO: false,
    USA_CIRCUITO: false,
    USA_TURISMO: false,
    USA_PACOTE: false,
    USA_SEGURO: false,
    USA_DISNEY: false,
    USA_CARRO: false,
    USA_AEREO: false,
    USA_LOJA: false,
    USA_CASA: false,
    USA_HOTEL: false,
    USA_BETO: false,
    USA_PROMOCIONAL: false,
    USA_MARKUPIMPRESSAO: false,
    USA_ARKBEDS: false,
    USA_TERMOMETRO: false,
    USA_SOLICITARDESCONTO: false,
    USA_CADASTROAGENCIA: false,
    USA_CADASTRO_CIRCUITO: false,
    USA_CADASTRO_APARTAMENTO_EXCLUSIVO: false,
    USA_TRADUTOR: false,
    USA_RODOVIARIO: false,
    //Apis dos módulos de turismo
    TURISMO_AEREO: API,
    TURISMO_HOTEL: API,
    TURISMO_SERVICO: API,
    TURISMO_SEGURO: API,
    TURISMO_CARRO: API,
    TURISMO: API,
    GERENCIAMENTO: API,
    EMPRESAS: API,

    //Módulos Adicionais
    USA_BLOQUEIO_FRT: false, // Permite o uso de um botão adicional na aba bloqueios
    USA_INTRANET: true, // Permite o uso da Intranet no portal
    USA_LAMINAS: true, // Permite Gerar Lâminas no portal
    USA_BANNERS: true, //Permite o uso de Banners

    //Configurações
    USA_PACOTESIMPLIFICADO: false,
    CLIENT_ID: "postman:123",
    MAPBOX_ACCESSTOKEN: "",
    ITENSPORPAGINA: 20,
    MAXIMO_QUARTOS: 8,
    TAG_GOOGLE: "",
    URLSITE: ''
};
